import { useAuth } from "../../hooks/useAuth";
import { Link } from "react-router-dom";
import { Building2, Users, Calendar, Activity, LogOut, Scale, User } from "lucide-react";

const TenantDashboard = () => {
    const { user, tenant, logout } = useAuth();

    const stats = [
        { label: "Total Patients", value: "0", icon: <Users className="h-6 w-6" />, color: "bg-primary-50 text-primary-600" },
        { label: "Appointments", value: "0", icon: <Calendar className="h-6 w-6" />, color: "bg-secondary-50 text-secondary-600" },
        { label: "Active Doctors", value: "0", icon: <Activity className="h-6 w-6" />, color: "bg-blue-50 text-blue-600" },
    ];

    return (
        <div className="space-y-8 p-6 lg:p-10 bg-gray-50 min-h-screen">
            {/* Header bar with Logout */}
            <div className="flex justify-between items-center bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <div className="flex items-center gap-3">
                    <div className="h-8 w-8 rounded-lg bg-primary-500 flex items-center justify-center text-white font-bold">
                        H
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
                            {tenant?.hospitalName || "Hospital Portal"}
                        </h1>
                        <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider">
                            Logged in as: {user?.role}
                        </p>
                    </div>
                </div>

                <div className="flex items-center gap-2.5">
                    <Link
                        to="/admin/profile"
                        className="flex items-center gap-2 px-3.5 py-2 text-sm font-medium text-neutral-700 bg-neutral-100 hover:bg-neutral-200 rounded-lg transition-colors duration-200"
                    >
                        <User size={16} />
                        <span>Profile</span>
                    </Link>
                    <button
                        onClick={logout}
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors duration-200"
                    >
                        <LogOut size={16} />
                        <span>Sign Out</span>
                    </button>
                </div>
            </div>

            <div>
                <h1 className="text-3xl font-bold text-gray-900">
                    Welcome back, {user?.name}
                </h1>
                <p className="text-gray-500 mt-2">
                    Access your clinical tools and analytics dashboard.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {stats.map((stat, index) => (
                    <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
                        <div className={`${stat.color} p-3 rounded-lg`}>
                            {stat.icon}
                        </div>
                        <div>
                            <p className="text-sm text-gray-500 font-medium">{stat.label}</p>
                            <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center justify-center text-center space-y-4">
                <div className="h-16 w-16 bg-primary-50 rounded-full flex items-center justify-center">
                    <Building2 className="h-8 w-8 text-primary-500" />
                </div>
<div>
                <h2 className="text-xl font-bold text-gray-900">Precision Care Initialized</h2>
                <p className="text-gray-500 max-w-md mx-auto mt-2">
                    Your hospital infrastructure is ready. You can now start adding doctors and managing patients.
                </p>
            </div>
        </div>

        {/* Footer / Legal area */}
        <footer className="bg-white rounded-xl shadow-sm border border-gray-100 px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-gray-400">
                <Scale size={15} />
                <span className="text-xs font-semibold uppercase tracking-wider">Legal</span>
            </div>
            <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm" aria-label="Legal documents">
                <Link to="/admin/legal?type=TERMS_AND_CONDITIONS" className="text-gray-600 hover:text-primary-600 transition-colors">
                    Terms &amp; Conditions
                </Link>
                <Link to="/admin/legal?type=PRIVACY_POLICY" className="text-gray-600 hover:text-primary-600 transition-colors">
                    Privacy Policy
                </Link>
                <Link to="/admin/legal?type=MEDICAL_DISCLAIMER" className="text-gray-600 hover:text-primary-600 transition-colors">
                    Medical Disclaimer
                </Link>
                <Link to="/admin/legal/history" className="text-primary-600 hover:text-primary-700 font-medium transition-colors">
                    My Acceptance History
                </Link>
                <Link to="/admin/legal" className="text-primary-600 hover:text-primary-700 font-medium transition-colors">
                    View all legal documents
                </Link>
            </nav>
        </footer>
    </div>
);
};

export default TenantDashboard;
